/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

export enum SkinKeys {
  nichtUntersucht = 'NICHT_UNTERSUCHT',
  pathologisch = 'PATHOLOGISCH',
  stehendeHautfalten = 'STEHENDE_HAUTFALTEN',
  dekubitus = 'DEKUBITUS',
  exanthem = 'EXANTHEM',
  oedeme = 'OEDEME',
  kaltschweissig = 'KALTSCHWEISSIG',
}

export const skinLabels: [SkinKeys, string][] = [
  [SkinKeys.nichtUntersucht, 'nicht untersucht'],
  [SkinKeys.pathologisch, 'pathologisch'],
  [SkinKeys.stehendeHautfalten, 'stehende Hautfalten'],
  [SkinKeys.dekubitus, 'Dekubitus'],
  [SkinKeys.exanthem, 'Exanthem'],
  [SkinKeys.oedeme, 'Oedeme'],
  [SkinKeys.kaltschweissig, 'kaltschweißig'],
];
